var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"ok-only":"","ok-title":"بستن","ok-variant":"warning","id":"attributes-info","title":"ویژگی ها"}},[(_vm.attributesInfo && !(Array.isArray(_vm.attributesInfo) && _vm.attributesInfo.length === 0))?_vm._l((Object.entries(_vm.attributesInfo)),function(ref){
var key = ref[0];
var value = ref[1];
return _c('div',{staticClass:"mt-3 mb-5"},[_c('h5',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(key))]),_c('hr',{staticClass:"mt-1"}),_c('ul',_vm._l((Object.entries(value)),function(ref){
var _key = ref[0];
var _value = ref[1];
return _c('li',[_c('span',[_vm._v(_vm._s(_key)+": ")]),_c('span',[_vm._v(_vm._s(_value))])])}),0)])}):[_vm._v("ویژگی وجود ندارد")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }